<script>
import { DropdownMenu } from 'element-ui';

export default {
  extends: DropdownMenu,
};
</script>

<style lang="scss" scoped>
  .el-dropdown-menu {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0 5px 10px #2980b91a;
    border: 1px solid #c9dfed;
    border-radius: 10px;
    padding: 12px;
  }

  .el-dropdown-menu--new-design {
    border-radius: 8px;
    border: 1px solid $--border-primary;
    box-shadow: $--shadow-100;
    margin-top: 2px;
    padding: 4px 12px;

    @media only screen and (max-width: $--sm - 1px) {
      padding: 0 16px;
    }
  }

  .el-dropdown-menu--no-spacing {
    :deep(.el-dropdown-menu__item) {
      margin: 0;
      padding: 0;
    }
  }
</style>
